import { useTheme } from '@emotion/react';
import { Alert, alpha } from '@mui/material';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';

const StyledAlert = styled(Alert)(
  ({ theme }) => {
    if (theme.isDark) {
      return {
        backgroundColor: alpha(theme.palette.primary.dark, 0.3),
      };
    }
  },
  ({ theme }) => {
    if (theme.isDark && theme.palette.isHighContrast) {
      return {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      };
    }
  },
);

const DefaultModelWarning = () => {
  const theme = useTheme();

  return (
    <StyledAlert severity={theme.palette.isHighContrast ? 'warning' : 'info'}>
      <FormattedMessage id="editor.model_editor.model_selector.model_settings.dialog.activation_controls.default_model_warning" />
    </StyledAlert>
  );
};

export default DefaultModelWarning;
